<template>
  <div class="set-info">
    <van-cell-group class="content" v-if="tag == 'nickname'">
      <van-field v-model="value" placeholder="最多可输入15个字" maxlength="15" />
    </van-cell-group>
    <ul class="content" v-else>
      <li :class="{ active: value == 0 }" @click="onSex(0)">男</li>
      <li :class="{ active: value == 1 }" @click="onSex(1)">女</li>
      <li :class="{ active: value == 3 }" @click="onSex(3)">保密</li>
    </ul>
    <footer-btn title="保存" @submit="onSave" />
  </div>
</template>

<script>
export default {
  name: "set-info",
  data() {
    return {
      title: {
        name: "修改昵称"
      },
      value: this.$route.query.value,
      tag: this.$route.query.tag
    };
  },
  created() {
    if (this.tag == "sex") {
      this.title.name = "性别";
    }
  },
  methods: {
    onSave() {
      switch (this.tag) {
        case "nickname":
          if (!this.value) {
            this.$toast("昵称不能为空");
            return;
          }
          this.$http.put("/api/app/user", { nickname: this.value }).then(() => {
            this.$router.go(-1);
          });
          break;
        case "sex":
          this.$http.put("/api/app/user", { sex: this.value }).then(() => {
            this.$router.go(-1);
          });
          break;
      }
    },
    onSex(val) {
      this.value = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.set-info {
  @extend %default-bg;
  ul {
    background: #fff;
    padding: 10px 30px;
    li {
      height: 110px;
      line-height: 110px;
      font-size: 28px;
      color: #595959;
      position: relative;
      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        background-color: #f5f5f5;
      }
      &:last-child:after {
        display: none;
      }
      &.active {
        background: url("~@/assets/theme-img/icon-check.png") no-repeat right
          center;
        background-size: 30px 30px;
      }
    }
  }
}
</style>
